import React from 'react';
import './styles.scss';

class NotFound extends React.Component {
	render() {
		return (
		<main id="not-found" className="main not-found">
			<h1>404</h1>
		</main>
		)
	}
};

export default NotFound;